/* eslint-disable */
import 'jquery.cookie';
import { TrackJS } from "trackjs";

let platform = window.appConfig.isMobileDomain ? 'mobile' : 'desktop';

const setDimension = () => {
	let enabledCookie = $.cookie('ab_enabled_' + platform),
		versionCookie = $.cookie('ab_version_' + platform);

	let dimension9 = enabledCookie === '1' ? "NEW_SITE" : "OLD_SITE",
		dimension6 = `${enabledCookie === '1' ? "b" : "a"}_${versionCookie}`;

	ga('set', 'dimension9', dimension9);
	ga('set', 'dimension6', dimension6);
};

const gaAsync = function(callback) {
	if(typeof(ga) !== "undefined") {
		if(_.isFunction(ga)) {
			setDimension();
			callback();
		} else {
			console.log(ga, JSON.stringify(ga));
			TrackJS.track("GA redefined");
		}
	} else {
		if(window.gaCallback.push == [].push) {
			window.gaCallback.push(setDimension);
			window.gaCallback.push(callback);
		}
	}
};

export default gaAsync;